import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Reservation,SecondInspection } from '../../../../models/Reservation';
import { Response } from '../../../../models/Response';
import { CardShadowComponent } from "../utils/card-shadow/card-shadow.component";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgIf } from '@angular/common';
import { NextSquareButtonDirective } from '../../../../shared/directives/buttons/next-square.directive';
import { FormInputDirective } from '../../../../shared/directives/forms/form-input.directive';
import { FormSelectSquareDirective } from '../../../../shared/directives/forms/form-select-square.directive';
import { NextButtonDirective } from '../../../../shared/directives/buttons/next.directive';
import { ReservationGesService } from '../../../../core/services/reservations/reservation-ges.service';
import { environment } from '../../../../../environments/environment';
import { UserService } from '../../../../core/services/users/user.service';
import { AuthStateService } from '../../../../../app/core/services/auth/auth-state.service';
import { BookFormService } from '../../../../core/services/book-form.service';
import { ReservationForm, Step1 } from "../../../../models/Front/ReservationForm";
import { Router } from '@angular/router';
@Component({
  selector: 'app-payment-card',
  standalone: true,
  imports: [
    CardShadowComponent,
    NgIf,
    CardShadowComponent,
    ReactiveFormsModule,
    NextSquareButtonDirective,
    FormInputDirective,
    FormSelectSquareDirective,
    NextButtonDirective
  ],
  templateUrl: './payment-card.component.html',
  styleUrl: './payment-card.component.css'
})
export class PaymentCardComponent implements OnChanges {
  @Input() existingReservation!: Reservation;
  showExtraInfoForm: boolean = false;
  extraInfoForm: FormGroup;
  userIsLoggedIn: boolean = false;
  operadorUser: boolean = false;
  public SecondInspection = SecondInspection;


  constructor(private reservationGes: ReservationGesService, private authService: AuthStateService, private bookFormService: BookFormService, private router: Router) {
    this.extraInfoForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      lightweight_vehicle: new FormControl(''),
      heavy_vehicle_over: new FormControl(''),
      diesel: new FormControl(''),
      farm_type: new FormControl(''),
      second_inspection: new FormControl('') 
    });

    this.authService.currentUser
      .subscribe({
        next: (user) => {
          if (user?.profile) {
            this.userIsLoggedIn = true;
          }

          if (user?.roles.some( role => role == 'operador') ) {
            this.operadorUser = true;
          }
        }
      })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['existingReservation']?.currentValue) {
      this.extraInfoForm.patchValue({
        email: this.existingReservation && this.existingReservation.email ? this.existingReservation.email : '',
        second_inspection: this.existingReservation.second_inspection || ''
      })
      // Fecha de matriculación (>= 1980) ya conocida por el censo de inspecciones:
      // se preselecciona, el usuario puede cambiarla.
      const over = this.existingReservation.heavy_vehicle_over;
      if (over !== null && over !== undefined) {
        this.extraInfoForm.patchValue({ heavy_vehicle_over: over ? 1 : 0 });
      }
      // Actualizamos los validadores en caso de que existingReservation cambie
      this.updateFormValidators();
    }
  }

  private updateFormValidators() {
    const vehicleId = this.existingReservation?.vehicle_id;
    const fuelId = this.existingReservation?.fuel_id;

    if (vehicleId === 1) {
      this.extraInfoForm.get('lightweight_vehicle')?.setValidators([Validators.required]);
    } else {
      this.extraInfoForm.get('lightweight_vehicle')?.clearValidators();
    }

    // El año (fecha de matriculación) solo determina la tasa de gases en diésel.
    // ITV: obligatorio elegir fecha de matriculación cuando el vehículo es diésel.
    const showsMatriculacionSelect = [1, 8, 4, 6, 9, 10].includes(vehicleId);
    const isDiesel = fuelId === 1;
    if (showsMatriculacionSelect && isDiesel) {
      this.extraInfoForm.get('heavy_vehicle_over')?.setValidators([Validators.required]);
    } else {
      this.extraInfoForm.get('heavy_vehicle_over')?.clearValidators();
    }

    if (fuelId === 3) {
      this.extraInfoForm.get('diesel')?.setValidators([Validators.required]);
    } else {
      this.extraInfoForm.get('diesel')?.clearValidators();
    }

    if (vehicleId === 7) {
      this.extraInfoForm.get('farm_type')?.setValidators([Validators.required]);
    } else {
      this.extraInfoForm.get('farm_type')?.clearValidators();
    }

    const service = this.existingReservation?.service_id;

    if (service === 2) {
      this.extraInfoForm.get('second_inspection')?.setValidators([Validators.required]);
    } else {
      this.extraInfoForm.get('second_inspection')?.clearValidators();
    }

    // Actualizar la validez de todos los campos después de cambiar los validadores
    this.extraInfoForm.updateValueAndValidity();
  }

  toggleShowExtraInfoForm() {
    this.showExtraInfoForm = !this.showExtraInfoForm;
  }

  onSubmit() {
    if (this.extraInfoForm.valid) {
      this.reservationGes.updateForPayment(this.extraInfoForm.value, this.existingReservation.id, this.existingReservation.phone).subscribe({
        next: (response: Response<Reservation>) => {
          this.toggleShowExtraInfoForm();
          let reference = this.existingReservation.station.code + this.existingReservation.id;
          let registration_number = this.existingReservation.registration_number;
          let phone = this.existingReservation.phone;
          //this.createLiquidation();
          let url = environment.production ? `https://taxes.conselldemallorca.net/Tasas/Itevebasa_ITV.aspx?referencia=${reference}&matricula=${registration_number}` : `https://cim-ha-taxes.intricom.es/Tasas/Itevebasa_ITV.aspx?referencia=${reference}&matricula=${registration_number}`;
          window.open(url);
          if (!this.userIsLoggedIn || !this.operadorUser) {
            this.router.navigate(['/'], {
              queryParams: { registration_number: registration_number, phone: phone }
            });
            sessionStorage.setItem('PaidTried', 'true');
          };
        },
        error: (err: any) => {
          console.error(err);
        }
      });

    } else {
      console.log('Formulario no válido');
    }
  }

  createLiquidation() {
    this.reservationGes.createLiquidation(this.existingReservation.id).subscribe({
      next: (response: any) => {
      },
      error: (err: any) => {
        console.error(err);
      }
    });
  }
}
